import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import { TimeUnits } from '../../Config/MedicationConfig';
import { numberInputFilter } from '../../Shared/InputFilters';
import { divider, errorText, warningGlowText } from '../../Styles/Colours';
import { MaskedTextField } from '../MaskedTextField';
import { isSingleSelectSingleValue, StyledSelect } from '../StyledSelect';
import styles from './DurationPicker.module.css';
export var renderItemToString = function (item) {
    switch (item.value) {
        case TimeUnits.Days:
            return 'Days';
        case TimeUnits.Months:
            return 'Months';
        case TimeUnits.Hours:
            return 'Hours';
        case TimeUnits.Minutes:
            return 'Minutes';
        case TimeUnits.Seconds:
            return 'Seconds';
    }
};
export var renderItemToMenuKey = function (item) { return item.value.toString(); };
export var selectableDurationTypes = [{ value: TimeUnits.Days }, { value: TimeUnits.Months }];
var useStyles = makeStyles({
    container: function (props) {
        var _a;
        return ({
            display: 'grid',
            gridTemplateColumns: 155,
            gridTemplateRows: (props.hideLabel ? 0 : '16px') + " " + ((_a = props.inputHeight) !== null && _a !== void 0 ? _a : 58) + "px",
            gridRowGap: 2,
            gridColumnStart: 1
        });
    },
    infoLine: function (props) { return ({
        color: props.error ? errorText : props.warning ? warningGlowText : divider,
        marginTop: 4,
        marginBottom: 2,
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.66,
        minHeight: 19
    }); }
});
export var DurationPicker = function (props) {
    var _a;
    var dynamicStyles = useStyles(props);
    var infoLine = props.error || props.warning || props.info;
    return (React.createElement("div", { className: dynamicStyles.container, "data-test-id": props.testId },
        !props.hideLabel && (React.createElement("div", { className: styles.durationLabel },
            React.createElement(InputLabel, { shrink: true, className: classNames((_a = {},
                    _a[styles.readOnlyLabel] = props.readOnly,
                    _a)) },
                "Course duration",
                props.required && React.createElement("span", { className: styles.requiredLabel }, " *")))),
        React.createElement("div", { className: styles.durationSelector },
            React.createElement("div", { className: styles.durationValue },
                React.createElement(MaskedTextField, { value: props.timeLength.number, hiddenLabel: true, fullWidth: true, filterFunction: numberInputFilter, onClear: function () {
                        return props.onUpdateTimeLength({
                            number: '',
                            timeUnits: props.timeLength.timeUnits
                        });
                    }, onChange: function (value) {
                        var enteredNumber = Number(value);
                        if (value && !isNaN(enteredNumber) && enteredNumber <= 999 && enteredNumber >= 1) {
                            props.onUpdateTimeLength({
                                number: value,
                                timeUnits: props.timeLength.timeUnits
                            });
                        }
                        else {
                            props.onUpdateTimeLength({
                                number: '',
                                timeUnits: props.timeLength.timeUnits
                            });
                        }
                    }, testId: 'duration-picker-number', readOnly: props.readOnly, disabled: props.disabled, errorText: props.error, hideErrorText: true, hideWarningEmptyHelperText: true })),
            React.createElement("div", { className: styles.durationType },
                React.createElement(StyledSelect, { isClearable: false, maxResults: 3, value: {
                        value: props.timeLength.timeUnits
                    }, itemToString: renderItemToString, itemToMenuKey: renderItemToMenuKey, onSelection: function (newDurationType) {
                        if (newDurationType && isSingleSelectSingleValue(newDurationType)) {
                            props.onUpdateTimeLength({
                                number: props.timeLength.number,
                                timeUnits: newDurationType.value
                            });
                        }
                    }, suggestions: selectableDurationTypes, testId: 'duration-picker-type', readOnly: props.readOnly, disabled: props.disabled, hideWarningEmptyHelperText: true }))),
        (infoLine || !props.hideWarningEmptyHelperText) && (React.createElement("div", { className: dynamicStyles.infoLine }, infoLine))));
};
